<template>
	<div class="error-page-wrapper">
		<div class="content content-centered error-page">
			<h2 data-test="page-not-found">Oops! We weren't able to find that page.</h2>
			<p class="error-description">If the problem persists, please <a href="http://momentumdash.com/contact">contact us</a>. <span class="u--quiet">Error code: 404</span></p>
			<p class="error-button-wrapper"><router-link class="button" to="/">Home</router-link></p>
		</div>
	</div>
</template>



<script>
export default {
	name: 'NotFound',
	created() {
		document.body.className += ' no-bg' // for white background
	},
	destroyed() {
		document.body.classList.remove('no-bg')
	},
}
</script>
